import React, { useEffect, useState } from "react";
import { Link } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import {
//   Typography,
//   Button,
//   Stepper,
//   Step,
//   StepLabel,
//   TextField,
// } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";

import {
  useForm,
  Controller,
  FormProvider,
  useFormContext,
} from "react-hook-form";
import Navbar from "./Navbar";
import DatePicker from "react-datepicker";
import axios from "../../login/Axios-interceptor";
// import axios from "axios";
import { CheckToken } from "../../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Switch from "react-switch";

import "./AdminComponents.scss";
import { toast } from "react-toastify";

function getSteps() {
  return [
    "Facility Attributes",
    "Facility Onboarding",
    "Price Setup",
    "User Set Up",
    "Compliance",
  ];
}
const WizardFacilityDetails = () => {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useFormContext();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [facilityTypes, setFacilityTypes] = useState([]);
  const [displayHCPRestEP, setDisplayHCPRestEP] = useState(false);
  console.log("displayHCPRestEP", displayHCPRestEP);
  const [facilitySubscription, setFacilitySubscription] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [partner, setPartner] = useState("");
  const [abdmEnabled, setAbdmEnabled] = useState(false);
  const [onTrial, setOnTrial] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [onGenAi, setOnGenAi] = useState(false);
  const [states, setStates] = useState("");
  const [cities, setCities] = useState([]);
  const [subscriptionList, setSubscriptionList] = useState([]);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const roleType = sessionStorage.getItem("roleType");

  useEffect(() => {
    setValue("abdm_enabled", true);
  }, [setValue]);

  const facilitySubscriptionW = watch("facility_subscription");

  // Watch for changes in facility_subscription to update abdm_enabled
  useEffect(() => {
    if (facilitySubscriptionW === "EHR/HMIS Service Without ABDM Connector") {
      setValue("abdm_enabled", false); // Turn off if specific option is selected
    } else {
      setValue("abdm_enabled", true); // Turn on for all other options
    }
  }, [facilitySubscriptionW, setValue]);

  useEffect(() => {
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "customer admin") &&
      Token()
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_clients/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            setClientList(res.data.client_list);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken]);

  useEffect(() => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_facility_subscription_types/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res);
          setSubscriptionList(res.data.subscription_types);
          console.log(res.data.subscription_types);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken]);

  const showEdit = getValues("showSearch");
  const selectedState = watch("address_state");
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
          headers: headers,
        })
        .then((res) => {
          setStates(res.data.state_list);
          console.log(res.data.state_list);
        });
    }
  }, [authToken]);

  const getStates = (stateName) => {
    console.log("stateName", stateName);
    var post_data = {
      state_name: stateName,
    };

    if (authToken !== "") {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_districts/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          setCities(res.data.district_list);
        });
    }
  };

  useEffect(() => {
    if (selectedState) {
      getStates(selectedState);
    }
  }, [selectedState]);

  useEffect(() => {
    setFacilitySubscription([
      "Choose Facility Subscription",
      "ABDM Connector/Adaptor - HIU/HIP",
      "ABDM Connector/Adaptor - HIU",
      "ABDM Connector/Adaptor - HIP",
      "Health Repository Provider (HRP) Service - HIU/HIP",
      "Health Repository Provider (HRP) Service - HIU",
      "Health Repository Provider (HRP) Service - HIP",
    ]);
  }, []);
  useEffect(() => {
    setFacilityTypes([
      "Hospital",
      "Lab & Diagnostics",
      "Both - Hospital & Lab Services",
      "Clinic",
      "Doctor",
      "MedTech Companies",
    ]);
  }, []);

  const facility_subscription = watch("facility_subscription");
  useEffect(() => {
    if (facility_subscription) {
      if (
        facility_subscription === facilitySubscription[1] ||
        facility_subscription === facilitySubscription[3]
      ) {
        setDisplayHCPRestEP(true);
      } else {
        setDisplayHCPRestEP(false);
      }
    }
  }, [facility_subscription]);
  useEffect(() => {
    const formData = getValues();
    setAbdmEnabled(formData.abdm_enabled);
  }, [getValues]);

  console.log(clientList);
  console.log("facility_subscription", facility_subscription);

  const client_name = watch("client_name");
  console.log("client_name", client_name);

  const clientName = watch("customer_name");

  useEffect(() => {
    if (clientName) {
      const post_data = {
        client_name: clientName,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_partner_from_client/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            console.log("Partner List:", response.data.partner);

            // setPartner(response.data.partner.partner_name);
            // setValue('partner_name', partnerName);
            const partnerName = response.data.partner.partner_name;
            setPartner(partnerName); // Set the partner state variable
            setValue("partner_name", partnerName); // Set the value of the partner_name field
          } else {
            console.error("API request failed:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [clientName]);
  useEffect(() => {
    // Trigger API call when the first client in the list is available
    if (clientList.length > 0) {
      const defaultClientName = clientList[0].client_name; // Get the first client's name
      setValue("customer_name", defaultClientName); // Set default selection in dropdown
      const post_data = {
        client_name: defaultClientName,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_partner_from_client/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            console.log("Partner List:", response.data.partner);

            const partnerName = response.data.partner.partner_name;
            setPartner(partnerName); // Set the partner state variable
            setValue("partner_name", partnerName); // Set the value of the partner_name field
          } else {
            console.error("API request failed:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [clientList]); // Depend on clientList

  return (
    <>
      {/* <DevTool control={control} /> */}
      {showEdit ? (
        <h1 style={{ textAlign: "center" }}>Edit Facility</h1>
      ) : (
        <h1 style={{ textAlign: "center" }}>Add New Facility</h1>
      )}

      <div className="row">
        <Controller
          name="facility_type"
          control={control}
          render={({ field }) => (
            <div className="col-12">
              <div className="form-group">
                <label className="required-label">Facility Type </label>
                {facilityTypes.map((item, index) => (
                  <div className="form-check" key={index}>
                    <input
                      rules={{ required: "this field is required." }}
                      type="radio"
                      id={item}
                      name="facility_type"
                      className="form-check-input"
                      value={item}
                      onChange={(e) => {
                        field.onChange(e);
                        setValue("facility_type", e.target.value); // Add this line
                      }}
                      checked={field.value === item}
                    />
                    <label className="form-check-label" htmlFor={item}>
                      {item}
                    </label>
                  </div>
                ))}
                {Boolean(errors?.facility_type) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.facility_type?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="facility_name"
          control={control}
          rules={{
            required: "This field is required.",
            pattern: {
              value: /^[a-zA-Z0-9\s]*$/,
              message: "Facility Name should not contain special characters.",
            },
          }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label className="required-label">Facility Name</label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Facility Name"
                  {...field}
                />
                {Boolean(errors?.facility_name) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.facility_name?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        {roleType !== "customer admin" && (
          <Controller
            name="customer_name"
            control={control}
            rules={{ required: "This field is required." }}
            render={({ field }) => (
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label className="required-label">Customer </label>
                <div className="form-group">
                  <i className="icon-user form-group-icon"></i>
                  <select
                    className="form-control"
                    name="customer_name"
                    placeholder="customer List"
                    {...field}
                    error={Boolean(errors?.customer_name)}
                    helperText={errors.customer_name?.message}
                  >
                    {clientList !== undefined && clientList.length > 0
                      ? clientList.map((item, index) => (
                          <option key={index} value={item.client_name}>
                            {item.client_name}
                          </option>
                        ))
                      : []}
                  </select>
                  {Boolean(errors?.client_name) && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.client_name?.message}
                    </p>
                  )}
                </div>
              </div>
            )}
          />
        )}
        {roleType !== "customer admin" && (
          <Controller
            name="partner_name"
            control={control}
            setValue=""
            render={({ field }) => (
              <div className="col-sm-6 col-md-6 col-lg-6">
                {/* <label className="required-label">Partner </label> */}
                <label>Partner </label>
                <div className="form-group">
                  <i className="icon-user form-group-icon"></i>
                  <input
                    className="form-control"
                    name="partner_name"
                    placeholder="partner"
                    {...field}
                    error={Boolean(errors?.partner_name)}
                    helperText={errors.partner_name?.message}
                    value={partner}
                    readOnly
                  />
                  {Boolean(errors?.partner_name) && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.partner_name?.message}
                    </p>
                  )}
                </div>
              </div>
            )}
          />
        )}
        <Controller
          name="facility_subscription"
          control={control}
          rules={{ required: "This field is required." }}
          defaultValue=""
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label className="required-label">Facility Subscription </label>
              <div className="form-group">
                <i className="icon-user form-group-icon"></i>
                <select
                  className="form-control"
                  {...field}
                  error={Boolean(errors?.facility_subscription)}
                  helperText={errors.facility_subscription?.message}
                >
                  {subscriptionList.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
                {Boolean(errors?.facility_subscription) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.facility_subscription?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        {displayHCPRestEP ? (
          <Controller
            name="hcp_rest_ep"
            control={control}
            rules={{ required: "This field is required." }}
            render={({ field }) => (
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label className="required-label">HCP Rest Endpoint </label>
                <div className="form-group form-group-date">
                  <i className="form-group"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter HCP Rest Endpoint"
                    name="hcp_rest_ep"
                    {...field}
                    error={Boolean(errors?.hcp_rest_ep)}
                    helperText={errors.hcp_rest_ep?.message}
                  />
                  {Boolean(errors?.hcp_rest_ep) && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.hcp_rest_ep?.message}
                    </p>
                  )}
                </div>
              </div>
            )}
          />
        ) : null}
        <Controller
          name="address_state"
          control={control}
          rules={{ required: "State is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label htmlFor="district" className="required-label">
                States{" "}
              </label>
              <div className="form-group">
                <select className="form-control" {...field}>
                  <option value="">Select State</option>
                  {states &&
                    states.map((state, index) => (
                      <option
                        key={index}
                        value={state.state_name.toLowerCase()}
                      >
                        {state.state_name}
                      </option>
                    ))}
                </select>
                {Boolean(errors?.address_state) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.address_state.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="address_city"
          control={control}
          rules={{ required: "City is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="city" className="required-label">
                  City
                </label>
                <select className="form-control" {...field}>
                  <option value="">Select City</option>
                  {cities.map((city, index) => (
                    <option
                      key={index}
                      value={city.district_name.toLowerCase()}
                    >
                      {city.district_name}
                    </option>
                  ))}
                </select>
                {errors.city && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.city.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="address_line_1"
          control={control}
          rules={{ required: "This field is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label className="required-label">Address</label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Address Line 1"
                  {...field}
                  error={Boolean(errors?.address_line_1)}
                  helperText={errors.address_line_1?.message}
                />
                {Boolean(errors?.address_line_1) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.address_line_1?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="address_line_2"
          control={control}
          // rules={{ required: "This field is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label>address_line_2</label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Address Line 2"
                  {...field}
                  error={Boolean(errors?.address_line_2)}
                  helperText={errors.address_line_2?.message}
                />
                {Boolean(errors?.address_line_2) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.address_line_2?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="address_line_3"
          control={control}
          // rules={{ required: "This field is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label>address_line_3</label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Address Line 3"
                  {...field}
                  error={Boolean(errors?.address_line_3)}
                  helperText={errors.address_line_3?.message}
                />
                {Boolean(errors?.address_line_3) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.address_line_3?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="address_pin"
          control={control}
          rules={{
            required: "This field is required.",
            pattern: {
              value: /^[0-9]+$/,
              message: "Address PIN must contain only numbers.",
            },
          }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label htmlFor="address_pin" className="required-label">
                Address PIN{" "}
              </label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Address PIN"
                  {...field}
                  error={Boolean(errors?.address_pin)}
                  helperText={errors.address_pin?.message}
                />
                {Boolean(errors?.address_pin) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.address_pin?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="phone"
          control={control}
          rules={{
            required: "Mobile number is required.",
            pattern: {
              value: /^[0-9]{10}$/,
              message: "phone number must be a 10-digit number.",
            },
          }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label htmlFor="phone" className="required-label">
                Phone{" "}
              </label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Phone"
                  {...field}
                  error={Boolean(errors?.phone)}
                  helperText={errors.phone?.message}
                />
                {Boolean(errors?.phone) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.phone?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{ required: "This field is required." }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label htmlFor="email" className="required-label">
                Email{" "}
              </label>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Email"
                  {...field}
                  error={Boolean(errors?.email)}
                  helperText={errors.email?.message}
                />
                {Boolean(errors?.email) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.email?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        <Controller
          name="mobile"
          control={control}
          rules={{
            // required: "Mobile number is required.",
            pattern: {
              value: /^[0-9]{10}$/,
              message: "Mobile number must be a 10-digit number.",
            },
          }}
          render={({ field }) => (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label htmlFor="mobile" className="required-label">
                Mobile
              </label>

              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Mobile"
                  {...field}
                  error={Boolean(errors?.mobile)}
                  helperText={errors.mobile?.message}
                />
                {Boolean(errors?.mobile) && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.mobile?.message}
                  </p>
                )}
              </div>
            </div>
          )}
        />
        {watch("facility_subscription") !==
          "ABDM Connector/Adaptor - HIU/HIP" &&
          watch("facility_subscription") !== "ABDM Connector/Adaptor - HIP" && (
            <div className="col-sm-6 col-md-6 col-lg-6"></div>
          )}
        <Controller
          name="abdm_enabled"
          control={control}
          render={({ field }) => (
            <div className="col-xs-6 col-sm-6 col-md-3">
              <div className="form-group">
                <label>ABDM Enabled</label>
                <Switch
                  disabled
                  {...field}
                  checked={field.value} // Controlled by form value
                  onChange={(checked) => {
                    field.onChange(checked);
                  }}
                  handleDiameter={15}
                />
              </div>
            </div>
          )}
        />
        <Controller
          name="ai_enabled"
          control={control}
          render={({ field }) => (
            <div className="col-xs-6 col-sm-6 col-md-3">
              <div className="form-group">
                <label>Leverage GenAI</label>
                <Switch {...field} checked={field.value} handleDiameter={15} />
              </div>
            </div>
          )}
        />
        <Controller
          name="email_enabled"
          control={control}
          render={({ field }) => (
            <div className="col-xs-6 col-sm-6 col-md-3">
              <div className="form-group">
                <label>Email Services</label>
                <Switch {...field} checked={field.value} handleDiameter={15} />
              </div>
            </div>
          )}
        />{" "}
        <Controller
          name="trial_checkbox"
          control={control}
          render={({ field }) => (
            <div className="col-xs-6 col-sm-6 col-md-3">
              <div className="form-group">
                <label>Trial Period</label>
                <Switch {...field} checked={field.value} handleDiameter={15} />
              </div>
            </div>
          )}
        />
      </div>
    </>
  );
};

const WizardFileUpload = () => {
  const { control, setValue, getValues } = useFormContext();
  const {
    formState: { errors },
  } = useFormContext();

  // Initialize state to store the file data
  const [selectedCommonParameters, setSelectedCommonParameters] =
    useState(null);
  const [selectedFacilityConfiguration, setSelectedFacilityConfiguration] =
    useState(null);
  const [
    selectedTransactionConfiguration,
    setSelectedTransactionConfiguration,
  ] = useState(null);
  // Use useEffect to update the state when the component is re-rendered
  useEffect(() => {
    // Get the file data from the form data
    const formData = getValues();
    setSelectedCommonParameters(formData.common_parameters);
    setSelectedFacilityConfiguration(formData.facility_configuration);
    setSelectedTransactionConfiguration(formData.transaction_configuration);
  }, [getValues]);

  const handleCommonParametersSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("common_parameters", file);
      setSelectedCommonParameters(file);
    }
  };

  const handleFacilityConfigurationSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("facility_configuration", file);
      setSelectedFacilityConfiguration(file);
    }
  };

  const handleFacilityTransactionSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("transaction_configuration", file);
      setSelectedTransactionConfiguration(file);
    }
  };

  return (
    <>
      <h1 style={{ textAlign: "center" }}>Upload the CSV </h1>

      <div className="row" style={{ justifyContent: "center" }}>
        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <label>Parameters CSV</label>
          <label
            htmlFor="common-parameters-file"
            id="common-parameters-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="common-parameters-file"
              hidden
              accept=".csv"
              onChange={(e) => handleCommonParametersSelect(e)}
            />
            Parameters File
          </label>
          {errors.common_parameters && (
            <p className="errorMsg">{errors.common_parameters.message}</p>
          )}
          {selectedCommonParameters
            ? "Selected Common Parameters File: " +
              selectedCommonParameters.name
            : ""}
        </div>

        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
          <label>Configuration CSV</label>
          <label
            htmlFor="facility-configuration-file"
            id="facility-configuration-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="facility-configuration-file"
              hidden
              accept=".csv"
              onChange={(e) => handleFacilityConfigurationSelect(e)}
            />
            Configuration File
          </label>
          {errors.facility_configuration && (
            <p className="errorMsg">{errors.facility_configuration.message}</p>
          )}
          {selectedFacilityConfiguration
            ? "Selected Facility Configuration File: " +
              selectedFacilityConfiguration.name
            : ""}
        </div>

        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <label>Transaction CSV</label>
          <label
            htmlFor="transaction-configuration-file"
            id="transaction-configuration-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="transaction-configuration-file"
              hidden
              accept=".csv"
              onChange={(e) => handleFacilityTransactionSelect(e)}
            />
            Transaction File
          </label>
          {errors.transaction_configuration && (
            <p className="errorMsg">
              {errors.transaction_configuration.message}
            </p>
          )}
          {selectedTransactionConfiguration
            ? "Selected Facility Configuration File: " +
              selectedTransactionConfiguration.name
            : ""}
        </div>
      </div>
    </>
  );
};

const WizardPriceFileUpload = () => {
  const { control, setValue, getValues } = useFormContext();
  const {
    formState: { errors },
  } = useFormContext();

  // Initialize state to store the file data
  const [selectedConsultationFees, setSelectedConsultationFees] =
    useState(null);
  const [selectedTestsProcedures, setSelectedTestsProcedures] = useState(null);
  const [selectedProucts, setSelectedProucts] = useState(null);

  // Use useEffect to update the state when the component is re-rendered
  useEffect(() => {
    // Get the file data from the form data
    const formData = getValues();
    setSelectedConsultationFees(formData.consultation_fees);
    setSelectedTestsProcedures(formData.tests_procedures);
    setSelectedProucts(formData.medical_products);
  }, [getValues]);

  const handleConsultationFeesSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("consultation_fees", file);
      setSelectedConsultationFees(file);
    }
  };

  const handleTestsProceduresSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("tests_procedures", file);
      setSelectedTestsProcedures(file);
    }
  };

  const handleProductSelect = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Store the selected file in React Hook Form
      setValue("medical_products", file);
      setSelectedProucts(file);
    }
  };

  return (
    <>
      <h1 style={{ textAlign: "center" }}>Fees and Tests & Procedures</h1>

      <div className="row" style={{ justifyContent: "center" }}>
        <div
          className="col-xs-12 col-sm-6 col-md-4 col-lg-3"
          style={{ display: "inline-block", width: "48%", marginRight: "2%" }}
        >
          <label>Consultation Fees CSV</label>
          <label
            htmlFor="consultation-fees-file"
            id="consultation-fees-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="consultation-fees-file"
              hidden
              accept=".csv"
              onChange={(e) => handleConsultationFeesSelect(e)}
            />
            Add File
          </label>
          {errors.consultation_fees && (
            <p className="errorMsg">{errors.consultation_fees.message}</p>
          )}
          {selectedConsultationFees
            ? "Selected Consultation Fees File: " +
              selectedConsultationFees.name
            : ""}
        </div>

        <div
          className="col-xs-12 col-sm-6 col-md-4 col-lg-3"
          style={{ display: "inline-block", width: "48%" }}
        >
          <label>Tests & Procedures CSV</label>
          <label
            htmlFor="tests-procedures-file"
            id="tests-procedures-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="tests-procedures-file"
              hidden
              accept=".csv"
              onChange={(e) => handleTestsProceduresSelect(e)}
            />
            Add File
          </label>
          {errors.tests_procedures && (
            <p className="errorMsg">{errors.tests_procedures.message}</p>
          )}
          {selectedTestsProcedures
            ? "Selected Tests & Procedures File: " +
              selectedTestsProcedures.name
            : ""}
        </div>

        <div
          className="col-xs-12 col-sm-6 col-md-4 col-lg-3"
          style={{ display: "inline-block", width: "48%" }}
        >
          <label>Product CSV</label>
          <label
            htmlFor="product-file"
            id="product-button-upload"
            className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
          >
            <input
              type="file"
              id="product-file"
              hidden
              accept=".csv"
              onChange={(e) => handleProductSelect(e)}
            />
            Add File
          </label>
          {errors.medical_products && (
            <p className="errorMsg">{errors.medical_products.message}</p>
          )}
          {selectedProucts
            ? "Selected Tests & Procedures File: " + selectedProucts.name
            : ""}
        </div>
      </div>
    </>
  );
};

const WizardAdminRegister = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    watch,
  } = useFormContext();
  const { control } = useFormContext();
  const [customerList, setCustomerList] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const editMode = getValues("showSearch");
  console.log("show search", editMode);
  useEffect(() => {
    // const post_data = {
    //     role_type: roleType,
    // };
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_clients/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(" client data", res.data);
          console.log("In client func", res.data.client_list);
          setCustomerList(res.data.client_list);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, []);
  const roleType = sessionStorage.getItem("roleType");

  if (editMode) {
    return (
      <>
        <h1 style={{ textAlign: "center" }}>Edit Facility Admin</h1>
        <h3 style={{ textAlign: "center" }}>to edit admins go to Edit Tools</h3>
      </>
    );
  }

  return (
    <>
      <h1 style={{ paddingLeft: "10%" }}>Add New Facility Admin</h1>

      <form className="contact-panel__form">
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              {/* <i className="icon-news form-group-icon"></i> */}

              <Controller
                name="user_id"
                control={control}
                render={({ field }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User ID"
                    disabled
                    value={""}
                    {...field}
                    hidden
                  />
                )}
              />
            </div>
          </div>

          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email is required.",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            }}
            render={({ field }) => (
              <div className="col-12">
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email"
                    {...field}
                    error={Boolean(errors?.email)}
                    helperText={errors.email?.message}
                  />
                  {Boolean(errors?.email) && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.email?.message}
                    </p>
                  )}
                </div>
              </div>
            )}
          />

          <div className="col-12">
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <Controller
                name="username"
                control={control}
                rules={{
                  required: "User Name is required.",
                }}
                render={({ field }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User Name"
                    autoComplete="off"
                    {...field}
                  />
                )}
              />
              {errors.username && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.username.message}
                </p>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <Controller
                name="password"
                control={control}
                rules={{
                  required: "Password is required.",
                  minLength: {
                    value: 8, // Minimum length of 8 characters
                    message: "Password must be at least 8 characters.",
                  },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, // Requires at least one lowercase, one uppercase, and one digit
                    message:
                      "Password must contain at least one uppercase letter, one lowercase letter, and one digit.",
                  },
                }}
                render={({ field }) => (
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password"
                    autoComplete="off"
                    {...field}
                  />
                )}
              />
              {errors.password && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.password.message}
                </p>
              )}
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <Controller
                name="first_name"
                control={control}
                rules={{
                  required: "First name is required.",
                  pattern: {
                    value: /^[a-zA-Z]+$/,
                    message: "This field must contain only alphabets.",
                  },
                }}
                render={({ field }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter First Name"
                    {...field}
                  />
                )}
              />
              {errors.first_name && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.first_name.message}
                </p>
              )}
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <Controller
                name="last_name"
                control={control}
                rules={{
                  required: "Last name is required.",
                  pattern: {
                    value: /^[a-zA-Z]+$/,
                    message: "This field must contain only alphabets.",
                  },
                }}
                render={({ field }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Last Name"
                    {...field}
                  />
                )}
              />
              {errors.last_name && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.last_name.message}
                </p>
              )}
            </div>
          </div>
          {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <Controller
                                        name="dob"
                                        control={control}
                                        rules={{
                                            required: "DOB is required.",
                                        }}
                                        render={({ field }) => (
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder="Enter DOB"
                                                {...field}
                                            />
                                        )}
                                    />
                                    {errors.dob && (
                                        <p className="errorMsg" style={{ color: "red" }}>
                                            {errors.dob.message}
                                        </p>
                                    )}
                                </div>
                            </div> */}
          <div className="col-sm-12 col-md-6 col-lg-6">
            <label>Date of Birth</label>
            <div className="form-group form-group-date">
              <i className="icon-calendar form-group-icon"></i>
              <Controller
                name="dob"
                control={control}
                rules={{
                  required: "Date of Birth is required.",
                  validate: (value) => {
                    const enteredDate = new Date(value);
                    const today = new Date();
                    const minAgeDate = new Date(
                      today.setFullYear(today.getFullYear() - 15)
                    );
                    return (
                      enteredDate <= minAgeDate ||
                      "Age must be at least 15 years."
                    );
                  },
                }}
                // rules={{ required: " Date of birth is required." }}
                render={({ field }) => (
                  <input type="date" className="form-control" {...field} />
                )}
              />
              {errors.dob && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.dob.message}
                </p>
              )}
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <label>Address</label>
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <Controller
                name="address"
                control={control}
                rules={{
                  required: "Address is required.",
                }}
                render={({ field }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Address"
                    {...field}
                  />
                )}
              />
              {errors.address && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.address.message}
                </p>
              )}
            </div>
          </div>
          {roleType !== "customer admin" && (
            <div className="col-sm-6 col-md-6 col-lg-6">
              <label>Customer List</label>
              <div className="form-group">
                <i className="icon-user form-group-icon"></i>
                <Controller
                  name="customer"
                  control={control}
                  rules={{
                    required: "Customer is required.",
                  }}
                  render={({ field }) => (
                    <select className="form-control" {...field}>
                      <option value="">Select a customer</option>
                      {customerList.map((item, index) => (
                        <option key={index} value={item.client_name}>
                          {item.client_name}
                        </option>
                      ))}
                    </select>
                  )}
                />
                {errors.customer && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.customer.message}
                  </p>
                )}
              </div>
            </div>
          )}

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-group">
              <div className="form-check">
                <Controller
                  name="active"
                  control={control}
                  render={({ field }) => (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      placeholder="Active"
                      {...field}
                    />
                  )}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  Active
                </label>
              </div>
              {errors.active && (
                <p className="errorMsg" style={{ color: "red" }}>
                  {errors.active.message}
                </p>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

const WizardTrial = () => {
  const { control, setValue, getValues, watch } = useFormContext();
  const {
    formState: { errors },
  } = useFormContext();
  const startDate = watch("start_date");
  const endDate = watch("end_date");
  const startTime = watch("start_time");
  const endTime = watch("end_time");

  const discount_percentagea = getValues("discount_percentage");
  console.log("discount_percentagea", discount_percentagea);

  return (
    <>
      <h1 style={{ paddingLeft: "25%", marginLeft: "5%" }}>Trial Set up</h1>

      <div className="row">
        <div className="col-12">
          <label className="required-label">Discount(percentage)</label>
          <div className="form-group">
            <Controller
              name="discount_percentage"
              control={control}
              rules={{
                required: "Discount Percentage is required.",
                validate: (value) =>
                  value <= 100 || "Discount Percentage must not exceed 100.",
              }}
              render={({ field }) => (
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Discount %"
                  {...field}
                />
              )}
            />
            {errors.discount_percentage && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.discount_percentage.message}
              </p>
            )}
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">Start Date</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              name="start_date"
              control={control}
              rules={{ required: "Start Date is required." }}
              render={({ field }) => (
                <input type="date" className="form-control" {...field} />
              )}
            />
            {errors.start_datetime && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.start_datetime.message}
              </p>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">Start Time</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              name="start_time"
              control={control}
              render={({ field }) => (
                <input type="time" className="form-control" {...field} />
              )}
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">End Date</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              name="end_date"
              control={control}
              rules={{
                required: "End Date is required.",
                validate: () =>
                  !startDate ||
                  !endDate ||
                  new Date(startDate) <= new Date(endDate) ||
                  "Start Date must not exceed End Date.",
              }}
              render={({ field }) => (
                <input type="date" className="form-control" {...field} />
              )}
            />
            {errors.end_date && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.end_date.message}
              </p>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">End Time</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              rules={{
                validate: () => {
                  if (startDate === endDate && startTime && endTime) {
                    return (
                      startTime <= endTime ||
                      "Start Time must not exceed End Time when dates are the same."
                    );
                  }
                  return true;
                },
              }}
              name="end_time"
              control={control}
              render={({ field }) => (
                <input type="time" className="form-control" {...field} />
              )}
            />
            {errors.end_time && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.end_time.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const WizardComplaince = () => {
  const { control, setValue, getValues } = useFormContext();
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <h1 style={{ textAlign: "center" }}>Compliance</h1>

      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">Planned Completion Date</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              name="planned_completion_date"
              control={control}
              rules={{ required: "Planned Completion Date is required." }}
              render={({ field }) => (
                <input type="date" className="form-control" {...field} />
              )}
            />
            {errors.planned_completion_date && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.planned_completion_date.message}
              </p>
            )}
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-6">
          <label className="required-label">Actual Completion Date</label>
          <div className="form-group form-group-date">
            <i className="icon-calendar form-group-icon"></i>
            <Controller
              name="actual_completion_date"
              control={control}
              rules={{ required: "Actual Completion Date is required." }}
              render={({ field }) => (
                <input type="date" className="form-control" {...field} />
              )}
            />
            {errors.actual_completion_date && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.actual_completion_date.message}
              </p>
            )}
          </div>
        </div>
        {/* <div className="col-sm-6 col-md-6 col-lg-6">
          <div className="form-group">
            <div className="form-check">
              <Controller
                name="wasa_audit_completed"
                control={control}
                render={({ field }) => (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    {...field}
                  />
                )}
              />
              <label
                className="form-check-label"
                htmlFor="wasa_audit_completed"
              >
                WASA Audit Completed
              </label>
            </div>
            {errors.wasa_audit_completed && (
              <p className="errorMsg" style={{ color: "red" }} >
                {errors.wasa_audit_completed.message}
              </p>
            )}
          </div>
        </div> */}

        <div className="col-sm-6 col-md-6 col-lg-6">
          <label className="required-label">WASA Audit Completed?</label>
          <div className="form-group">
            <div className="form-check">
              <Controller
                name="wasa_audit_completed"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      type="radio"
                      id="wasa_audit_completed_yes"
                      className="form-check-input"
                      {...field}
                      value={true} // Value is boolean true
                      checked={field.value === true} // Checked condition
                      onChange={() => field.onChange(true)} // Update form state
                    />
                    <label
                      className="form-check-label"
                      htmlFor="wasa_audit_completed_yes"
                    >
                      Yes
                    </label>

                    <input
                      type="radio"
                      id="wasa_audit_completed_no"
                      className="form-check-input"
                      {...field}
                      value={false} // Value is boolean false
                      checked={field.value === false} // Checked condition
                      onChange={() => field.onChange(false)} // Update form state
                    />
                    <label
                      className="form-check-label"
                      htmlFor="wasa_audit_completed_no"
                    >
                      No
                    </label>
                  </>
                )}
              />
            </div>

            {errors.wasa_audit_completed && (
              <p className="errorMsg" style={{ color: "red" }}>
                {errors.wasa_audit_completed.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

function getStepContent(step, trialCheckboxSelected) {
  switch (step) {
    case 0:
      return <WizardFacilityDetails />;
    case 1:
      return <WizardFileUpload />;
    case 2:
      return <WizardPriceFileUpload />;
    case 3:
      return <WizardAdminRegister />;
    case 4:
      return trialCheckboxSelected ? null : <WizardComplaince />;
    case 5:
      return trialCheckboxSelected ? <WizardComplaince /> : null;
    default:
      return "unknown step";
  }
}

const FACILITY_INFO_STORAGE_KEY = "facilityInfo";

const FacilityDetails = ({ updateList }) => {

  const [facilityId, setFacilityId] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [facilityEditId, setFacilityEditId] = useState();

  const methods = useForm({
    defaultValues: {
      account_id: "",
      abdm_id: "",
      service_type_id: "",
      facility_name: "",
      address_line_1: "",
      address_line_2: "",
      address_line_3: "",
      address_city: "",
      address_state: "",
      address_pin: "",
      phone: "",
      email: "",
      mobile: "",
      creation_datetime: "",
      modification_datetime: "",
      user_id: "",
      email: "",
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      dob: "",
      address: "",
      active: "",
      client_name: "",
      facility_type: "",
      hcp_rest_ep: "",
      facility_id: "",
      customer: "",
      trial_checkbox: false,
      wasa_audit_completed: false,
      abdm_enabled: false,
      email_enabled: false,
      ai_enabled: false,
      showSearch: false,
      address_state: "",
      address_city: "",
      facility_edit_id: "",
      customer_name: "",
      address_state: "",
      address_city: "",
      partner_name: "",
      facility_subscription: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      planned_completion_date: "",
      actual_completion_date: "",
      wasa_audit_completed: "",
      selectedTransactionConfiguration: "",
    },
  });
  // const steps = getSteps();

  const {
    register: register,
    handleSubmit: handleSubmit,
    formState: { errors: errors },
    setError: setError,
    getValues: getValues,
    watch: watch,
    setValue: setValue,
    reset,
  } = useForm();
  const selectedFacility = getValues("facilityName");
  const isStepFalied = () => {
    return Boolean(Object.keys(methods.formState.errors).length);
  };
  const isStepSkipped = (step) => {
    return skippedSteps.includes(step);
  };

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  // function getStepContent(step) {
  //     switch (step) {
  //         case 0:
  //             return <WizardFacilityDetails />;

  //         case 1:
  //             return <WizardFileUpload />;
  //         case 2:
  //             return <WizardAdminRegister />;
  //         case 3:
  //             return;
  //         case 4:
  //             return <WizardComplaince />
  //         default:
  //             return "unknown step";
  //     }
  // }
  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "customer admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);
  useEffect(() => {
    if (activeStep === steps.length) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 3000); // Reload after 3 seconds

      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, [activeStep]);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const [showTrialPage, setShowTrialPage] = useState(false);
  // const steps = getSteps().concat(showTrialPage ? ["Trial Setup"] : []);
  const steps = getSteps();
  if (showTrialPage) {
    steps.splice(4, 0, "Trial Setup");
  }

  console.log(steps);
  const handleNext = (data) => {
    console.log(getValues("facility_edit_id"));
    data.facility_id = getValues("facility_edit_id");

    if (activeStep === 0) {
      const trialCheckbox = data.trial_checkbox;

      if (trialCheckbox) {
        setShowTrialPage(true);
        setSkippedSteps([]);
        console.log(trialCheckbox);
      } else {
        setShowTrialPage(false);
        setSkippedSteps([3]);
      }

      console.log("data", data);

      // Define a function to handle the "customer admin" case
      const updateDataForCustomerAdmin = async () => {
        if (
          sessionStorage.getItem("roleType") === "customer admin" &&
          Token()
        ) {
          try {
            const res = await axios.get(
              `${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`,
              {
                headers: headers,
              }
            );

            if (res.data.status === "Success") {
              console.log("Logged In User data", res.data);
              return {
                ...data,
                customer_name: res.data.customer_name,
                partner_name: res.data.partner_name,
                customer: res.data.customer_name,
              };
            }
          } catch (err) {
            console.error(err);
            return data; // Return original data if error occurs
          }
        } else {
          return data;
        }
      };

      // Update data and proceed with the API call
      updateDataForCustomerAdmin().then((updatedData) => {
        console.log("Updated Data", updatedData);

        // Assuming facilityEditId is defined elsewhere
        updatedData.facility_id = facilityEditId;

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}add_update_services/`,
            JSON.stringify(updatedData),
            {
              headers: headers,
            }
          )
          .then((response) => {
            if (response.status === 200) {
              console.log(response.data);

              if (response.data.status === "Failed") {
                const errorMessage = response.data.message;

                if (errorMessage.includes("email")) {
                  toast.error(
                    "Duplicate email. Please use a different email address."
                  );
                } else if (errorMessage.includes("uniq")) {
                  toast.error(
                    "Duplicate facility. Please give a different facility name."
                  );
                } else {
                  console.error("Error:", errorMessage);
                }
              } else {
                setFacilityId(response.data.facility_id);
                setActiveStep(activeStep + 1);
                toast.success(response.data.status);
                updateList();
              }
            } else {
              console.error("Unexpected status code:", response.status);
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      });
    }
    if (activeStep === steps.length - 1) {
      if (Token()) {
        console.log(data);

        // axios
        //     .post(`${REACT_APP_BACKEND_ROUTE_URL}add_update_services/`, JSON.stringify(data), {
        //         headers: headers,
        //     })
        //     .then((response) => {
        //         console.log(response.data)
        //         setFacilityId(response.data.facility_id);
        if (showTrialPage) {
          const trialData = {
            facility_id: facilityId,
            trial_checkbox: data.trial_checkbox,
            discount_percentage: data.discount_percentage,
            start_date: data.start_date,
            end_date: data.end_date,
            start_time: data.start_time,
            end_time: data.end_time,
          };
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}add_facility_trial_data/`,
              JSON.stringify(trialData),
              {
                headers: headers,
              }
            )
            .then((response) => {
              // const HIP_ID = response.data.HIP_ID;
              // const ac = response.data.facility_id;
              // console.log("facility_id:", HIP_ID);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
        const formDataTransaction = new FormData();

        const formDataToSubmit = new FormData();
        // formDataToSubmit.append("HIP_ID", HIP_ID);
        // formDataToSubmit.append("account_id", response.data.facility_id); //customer id
        // formDataToSubmit.append("abdm_id", data.abdm_id);

        formDataToSubmit.append("service_type_id", data.service_type_id);
        formDataToSubmit.append("facility_name", data.facility_name);
        formDataToSubmit.append("address_line_1", data.address_line_1);
        formDataToSubmit.append("address_line_2", data.address_line_2);
        formDataToSubmit.append("address_line_3", data.address_line_3);
        formDataToSubmit.append("address_city", data.address_city);
        formDataToSubmit.append("address_state", data.address_state);
        formDataToSubmit.append("address_pin", data.address_pin);
        formDataToSubmit.append("phone", data.phone);
        formDataToSubmit.append("email", data.email);
        formDataToSubmit.append("mobile", data.mobile);
        formDataToSubmit.append("creation_datetime", data.creation_datetime);
        formDataToSubmit.append(
          "modification_datetime",
          data.modification_datetime
        );
        formDataToSubmit.append("user_id", data.user_id);
        formDataToSubmit.append("username", data.username);
        formDataToSubmit.append("password", data.password);
        formDataToSubmit.append("first_name", data.first_name);
        formDataToSubmit.append("last_name", data.last_name);
        formDataToSubmit.append("dob", data.dob);
        formDataToSubmit.append("address", data.address);
        formDataToSubmit.append("active", data.active);
        formDataToSubmit.append("customer_name", data.customer_name);
        formDataToSubmit.append("partner_name", data.partner_name);

        formDataToSubmit.append("facility_type", data.facility_type);
        formDataToSubmit.append("hcp_rest_ep", data.hcp_rest_ep);
        formDataToSubmit.append("facility_id", data.facility_id);
        formDataToSubmit.append("facility_subscription", facilityId);
        formDataToSubmit.append("HIP_ID", facilityId);

        if (showSearch) {
          formDataToSubmit.append("type", "update");
        } else {
          formDataToSubmit.append("type", "add");
        }

        if (data.facility_configuration) {
          formDataToSubmit.append(
            "facility_configuration",
            data.facility_configuration
          );
        }
        if (data.common_parameters) {
          formDataToSubmit.append("common_parameters", data.common_parameters);
        }
        if (data.consultation_fees) {
          formDataToSubmit.append("doctors_data", data.consultation_fees);
        }
        if (data.tests_procedures) {
          formDataToSubmit.append("tests_procedures", data.tests_procedures);
        }

        if (data.medical_products) {
          formDataToSubmit.append("medical_products", data.medical_products);
        }

        console.log("formdata testing...", formDataToSubmit);

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}facility_data_upload/`,
            formDataToSubmit,
            {
              headers: headers,
            }
          )
          .then((facilityResponse) => {
            if (facilityResponse.data.status !== "Failed") {
              if (data.transaction_configuration) {
                fileToBase64(data.transaction_configuration)
                  .then((base64File) => {
                    const requestBody = {
                      facility_id: facilityId,
                      config_file_base64: base64File,
                    };

                    return axios.post(
                      `${REACT_APP_BACKEND_ROUTE_URL}upload_transaction_config_file/`,
                      requestBody,
                      {
                        headers: headers,
                      }
                    );
                  })
                  .then((facilityTransactionResponse) => {
                    console.log(
                      "Facility Transaction Response:",
                      facilityResponse.data
                    );

                    if (facilityTransactionResponse.data.status !== "Failed") {
                      if (!showSearch) {
                        const userData = {
                          email: data.email,
                          username: data.username,
                          password: data.password,
                          first_name: data.first_name,
                          last_name: data.last_name,
                          dob: data.dob,
                          address: data.address,
                          facility: facilityId,
                          user_type: "Facility Admin",
                          customer: data.customer,
                          active: data.active,
                        };
                        axios
                          .post(
                            `${REACT_APP_BACKEND_ROUTE_URL}add_new_user/`,
                            JSON.stringify(userData),
                            {
                              headers: headers,
                            }
                          )
                          .then((userResponse) => {
                            console.log(
                              "Add User Response:",
                              userResponse.data
                            );

                            if (userResponse.data.status === "Success") {
                              toast.success("User Added !!");
                              console.log(userResponse);
                              setActiveStep(activeStep + 1);
                            } else if (userResponse.data.status === "Failed") {
                              toast.error(userResponse.data.message);
                            } else {
                              toast.error("User Not Added !! Try again later");
                              console.log(
                                "checcking..",
                                userResponse.data.message
                              );
                            }
                          });
                      } else {
                        setActiveStep(activeStep + 1);
                      }
                    } else {
                      const message =
                        facilityTransactionResponse.data.message ||
                        "An unknown error occurred.";

                      if (message.includes("corrupted")) {
                        toast.error(
                          "The Facility documents uploaded are corrupted. Please try with a different document."
                        );
                      } else if (message.includes("Virus")) {
                        toast.error(
                          "The Facility documents uploaded has virus. Please try with a different document."
                        );
                      } else {
                        toast.error(message);
                      }
                    }
                  })
                  .catch((facilityError) => {
                    console.error("Facility Transaction Error:", facilityError);
                  });
              } else {
                if (!showSearch) {
                  const userData = {
                    email: data.email,
                    username: data.username,
                    password: data.password,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    dob: data.dob,
                    address: data.address,
                    facility: facilityId,
                    user_type: "Facility Admin",
                    customer: data.customer,
                    active: data.active,
                  };
                  axios
                    .post(
                      `${REACT_APP_BACKEND_ROUTE_URL}add_new_user/`,
                      JSON.stringify(userData),
                      {
                        headers: headers,
                      }
                    )
                    .then((userResponse) => {
                      console.log("Add User Response:", userResponse.data);

                      if (userResponse.data.status === "Success") {
                        toast.success("User Added !!");
                        console.log(userResponse);
                        setActiveStep(activeStep + 1);
                      } else if (userResponse.data.status === "Failed") {
                        toast.error(userResponse.data.message);
                      } else {
                        toast.error("User Not Added !! Try again later");
                        console.log("checcking..", userResponse.data.message);
                      }
                    });
                } else {
                  setActiveStep(activeStep + 1);
                }
              }
              // } else {
              //   toast.error(facilityResponse.data.message);
              // }
            } else {
              const message =
                facilityResponse.data.message || "An unknown error occurred.";

              if (message.includes("corrupted")) {
                toast.error(
                  "The Facility documents uploaded are corrupted. Please try with a different document."
                );
              } else if (message.includes("Virus")) {
                toast.error(
                  "The Facility documents uploaded has virus. Please try with a different document."
                );
              } else {
                toast.error(message);
              }
            }
          })
          .catch((facilityError) => {
            console.error("Facility Data Upload Error:", facilityError);
          });

        function fileToBase64(file) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (error) => reject(error);
          });
        }

        const userDataAudit = {
          facility_id: facilityId,
          wasa_audit_checkbox: data.wasa_audit_completed,
          planned_completion_date: data.planned_completion_date,
          actual_completion_date: data.actual_completion_date,
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}add_facility_wasa_audit/`,
            JSON.stringify(userDataAudit),
            {
              headers: headers,
            }
          )
          .then((userResponse) => {
            // console.log("Add User Response:", userResponse.data);
            // setActiveStep(activeStep + 1);
          })
          .catch((errorWasa) => {
            console.error("Add User Error:", errorWasa);
          });

        // })
        // .catch((err) => {
        //     console.error("Error:", err);
        // });
      } else {
        console.log("User is not authenticated. Please log in.");
      }
    } else {
      console.log(data);
      if (activeStep !== 0) {
        setActiveStep(activeStep + 1);
      }

      setSkippedSteps(
        skippedSteps.filter((skipItem) => skipItem !== activeStep)
      );
    }
  };

  console.log("methods", methods);

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSkip = () => {
    if (!isStepSkipped(activeStep)) {
      setSkippedSteps([...skippedSteps, activeStep]);
    }
    setActiveStep(activeStep + 1);
  };

  const fetchFacilityInfo = (data) => {
    if (data.selectedFacility) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_facility_info/`,
          { facility_id: data.selectedFacility },
          { headers }
        )
        .then((response) => {
          const facilityData = response.data.message;

          const trialStartDate =
            facilityData.trial_start_date?.split("T")[0] || "";
          const trialEndDate = facilityData.trial_end_date?.split("T")[0] || "";

          const wasaStartDate =
            facilityData.actual_completion_date?.split("T")[0] || "";
          const wasaEndDate =
            facilityData.planned_completion_date?.split("T")[0] || "";

          methods.reset({
            account_id: "", // No mapping available in provided data
            abdm_id: "", // No mapping available in provided data
            service_type_id: "", // No mapping available in provided data
            facility_name: facilityData.facility_name || "",
            address_line_1: facilityData.facility_address_line_1 || "",
            // address_line_2: facilityData.facility_address?.address_line_2 || "",
            // address_line_3: facilityData.facility_address?.address_line_3 || "",
            address_line_2: facilityData.facility_address_line_2 || "",
            address_line_3: facilityData.facility_address_line_3 || "",
            address_pin: facilityData.pincode || "",
            phone: facilityData.phone || "",
            email: facilityData.email || "",
            // mobile: "", // No mapping available in provided data
            mobile: facilityData.mobile || "",
            creation_datetime: facilityData.date_of_creation || "",
            modification_datetime: "", // No mapping available in provided data
            user_id: "", // No mapping available in provided data
            username: "", // No mapping available in provided data
            password: "", // No mapping available in provided data
            first_name: "", // No mapping available in provided data
            last_name: "", // No mapping available in provided data
            dob: "", // No mapping available in provided data
            address: facilityData.facility_address?.full_address || "", // Assuming full address is available
            active: "", // No mapping available in provided data
            client_name: facilityData.client || "",
            facility_type: facilityData.facility_type || "",
            hcp_rest_ep: facilityData.endpoint || "",
            facility_id: facilityData.facility_id,
            customer: "", // No mapping available in provided data
            trial_checkbox: facilityData.trial || false,
            wasa_audit_completed: facilityData.wasa_audit,
            abdm_enabled: facilityData.abdm_enabled || false,
            email_enabled: facilityData.email_enabled || false,
            ai_enabled: facilityData.ai_enabled || false,
            showSearch: false, // Assuming this remains unchanged
            discount_percentage: facilityData.discount_percentage,
            start_date: trialStartDate || null,
            end_date: trialEndDate || null,
            facility_edit_id: facilityData.facility_id,
            customer_name: facilityData.client,
            address_state: facilityData.state,
            address_city: facilityData.city,
            partner_name: facilityData.partner,
            facility_subscription: facilityData.subscription_type,
            start_date: trialStartDate,
            end_date: trialEndDate,
            end_time: facilityData.trial_end_time,
            start_time: facilityData.trial_start_time,
            actual_completion_date: wasaStartDate,
            planned_completion_date: wasaEndDate,
            wasa_audit_completed: facilityData.wasa_audit,
          });
          setFacilityEditId(facilityData.facility_id);

          try {
            localStorage.setItem(
              FACILITY_INFO_STORAGE_KEY,
              JSON.stringify(facilityData)
            );
          } catch {
            /* quota — best-effort */
          }
        })
        .catch((error) => {
          console.error("Error fetching initial data:", error);
        });
    }
  };
  console.log("method");
  const handleFindClick = () => {
    setShowSearch(true);
    setValue("showSearch", true);
    methods.setValue("showSearch", true);
  };
  const handleClickDone = () => {
    setFacilityEditId("");
    setShowSearch(false);
    setValue("showSearch", false);
    methods.setValue("showSearch", false);
  };

  useEffect(() => {
    methods.setValue("showSearch", showSearch);
  }, [methods.getValues("showSearch"), showSearch]);

  const showSearchValue = methods.getValues("showSearch");
  console.log("Current value of showSearch:", showSearchValue);

  useEffect(() => {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(res);
          setFacilityList(res.data.facility_list);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken]);

  return (
    <div>
      {/* <Navbar /> */}

      <Stepper alternativeLabel activeStep={activeStep}>
        {steps.map((step, index) => {
          const labelProps = {};
          const stepProps = {};

          if (isStepFalied() && activeStep == index) {
            labelProps.error = true;
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step {...stepProps} key={index}>
              <StepLabel {...labelProps}>{step}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <div className="col-sm-12 col-md-12 col-lg-8" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50">
          <div className="row">
            {!showSearch && activeStep === 0 && (
              <>
                <div className="col-sm-6 col-md-6 col-lg-6"></div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Link
                    href="#"
                    onClick={handleFindClick}
                    className="hyperlink"
                    style={{ marginLeft: "10px" }}
                  >
                    <SearchIcon style={{ marginRight: "8px" }} />
                    Search/Edit Facility
                  </Link>
                </div>
              </>
            )}

            {showSearch && (
              <div style={{ margin: "auto" }}>
                <div className="contact-panel mb-50">
                  <form onSubmit={handleSubmit(fetchFacilityInfo)}>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <label className="required-label">Facility </label>
                        <div className="form-group">
                          <select
                            disabled={activeStep !== 0}
                            className="form-control"
                            name="selectedFacility"
                            {...register("selectedFacility")}
                          >
                            <option value="">Select Facility</option>
                            {facilityList.map((facility, index) => (
                              <option key={index} value={facility.facility_id}>
                                {facility.facility_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="row" style={{ margin: "auto" }}>
                        <div
                          className="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                          style={{ marginBottom: "10px" }}
                        >
                          <button
                            type="submit"
                            className="btn btn__secondary btn__rounded btn__block mt-6"
                            disabled={activeStep !== 0}
                          >
                            Search
                          </button>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <button
                            className="btn btn__secondary btn__rounded btn__block mt-6"
                            onClick={() => handleClickDone()}
                            disabled={activeStep !== 0}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

          {activeStep === steps.length ? (
            <Typography variant="h3" align="center">
              Facility Added!
            </Typography>
          ) : (
            <>
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleNext)}>
                  {/* {getStepContent(activeStep)} */}
                  {getStepContent(
                    activeStep,
                    methods.getValues("trial_checkbox")
                  )}
                  {showTrialPage && activeStep === 4 && (
                    // Only show 'wizardTrial' when showTrialPage is true and activeStep is 3
                    <WizardTrial />
                  )}
                  {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                                        <Button
                                            className={classes.button}
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                        >
                                            back
                                        </Button>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            color="primary"
                                            // onClick={handleNext}
                                            type="submit"
                                        >
                                            {activeStep === steps.length - 1 ? "Finish" : "Next"}
                                        </Button>
                                    </div> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                    >
                      back
                    </Button>
                    <Button
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                      variant="contained"
                      style={{ backgroundColor: "#213360", color: "#ffffff" }}
                      type="submit"
                    >
                      {activeStep === steps.length - 1 ? "Finish" : "Next"}
                    </Button>
                  </div>
                </form>
              </FormProvider>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FacilityDetails;
